import { Table } from 'antd';
import { useMemo, useState } from 'react';

import {
  CLIENT_TABLE_HEADER,
  CLIENTS_TABLE_SCROLL_X,
  U_KEY,
} from '@app/constants';
import type { NTables } from '@app/types/Tables';

import { adaptDataToTable } from '@pages/Clients/ClientsList/utils/adaptDataToTable';

export const ClientsTable: NTables.ClientsMain = ({
  loader,
  data,
  rowSelection,
  rowsPerPage,
  totalRowsCount,
  hasRightToEdit,
  handlePageChange,
  handleEdit,
  isMobile,
  pageNumber,
  hasUserRightToCommunicate,
}) => {
  const [selectionType] = useState<'checkbox' | 'radio'>('checkbox');

  const memoizedData = useMemo(() => {
    return totalRowsCount > 0
      ? adaptDataToTable(data, handleEdit, hasUserRightToCommunicate)
      : [];
  }, [data, handleEdit, hasUserRightToCommunicate, totalRowsCount]);

  return (
    <div>
      <Table
        className="table"
        loading={loader}
        rowSelection={{
          type: selectionType,
          ...rowSelection,
        }}
        rowKey={(record) => String(record[U_KEY])}
        columns={
          hasRightToEdit
            ? CLIENT_TABLE_HEADER
            : CLIENT_TABLE_HEADER.filter((item) => item.key !== 'Action')
        }
        dataSource={memoizedData}
        scroll={{ x: CLIENTS_TABLE_SCROLL_X }}
        pagination={{
          size: isMobile ? 'small' : 'default',
          showSizeChanger: true,
          total: totalRowsCount,
          pageSize: rowsPerPage,
          position: isMobile ? ['bottomCenter'] : ['bottomLeft'],
          current: pageNumber,
          onChange: handlePageChange,
          showTotal: (total, range) =>
            `Показаны ${range[0]}-${range[1]} из ${total}`,
        }}
      />
    </div>
  );
};
